var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"15%"}},[_vm._v("\n\tApproving Guest...\n")])}
var staticRenderFns = []

export { render, staticRenderFns }